'use client';

import { PropsWithChildren, useEffect, useRef } from 'react';

import { useUserStore } from '@entities/user';
import { getModuleByPlan, getModulesApi, useActiveModule, useModuleStore } from '@entities/module';
import { useActiveLesson } from '@entities/lesson';
import { useActiveQuiz } from '@entities/quiz';
import { getPyodideInstance } from '@shared/lib/pyodide';

const StoreProvider = (props: PropsWithChildren) => {
  const { children } = props;

  const authenticated = useUserStore((state) => state.authenticated);
  const setJupiterBaseUrl = useUserStore((state) => state.setJupiterBaseUrl);

  const activeModuleId = useModuleStore((state) => state.module?.id);
  const activePlanId = useModuleStore((state) => state.plan);
  const modulesUpdater = useModuleStore((state) => state.modulesUpdater);
  const setModule = useModuleStore((state) => state.setModule);
  const setModulesByPlan = useModuleStore((state) => state.setModulesByPlan);
  const setRecommendations = useModuleStore((state) => state.setRecommendations);
  const setPlans = useModuleStore((state) => state.setPlans);
  const setOverallProgress = useModuleStore((state) => state.setOverallProgress);
  const setTrialPaymentNeeded = useModuleStore((state) => state.setTrialPaymentNeeded);
  const setTrialPrice = useModuleStore((state) => state.setTrialPrice);

  const firstRender = useRef<boolean>(true);

  useActiveModule();
  useActiveLesson();
  useActiveQuiz();

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      getPyodideInstance();
    }
  }, []);

  useEffect(() => {
    if (!authenticated) {
      return;
    }

    getModulesApi().then((data) => {
      setModulesByPlan(data.modulesByPlan);
      setRecommendations(data.recommendations);
      setPlans(data.plans);
      setOverallProgress(data.overallProgress);
      setModule(getModuleByPlan(activeModuleId || '', activePlanId || '', data.modulesByPlan));
      setJupiterBaseUrl(data.jupiterBaseUrl);
      setTrialPaymentNeeded(data.trialPaymentNeeded);
      setTrialPrice(data.trialPrice);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, modulesUpdater]);

  return children;
};

export default StoreProvider;
